import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './EmailVerification.css';

function EmailVerification() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');

  const states = {
    success: {
      icon: 'bi-check-circle-fill',
      title: 'Email vérifié !',
      message:
        'Votre adresse email a été vérifiée avec succès. Votre compte est prêt à être utilisé.',
      type: 'success',
    },
    'already-verified': {
      icon: 'bi-shield-check',
      title: 'Email déjà vérifié',
      message:
        'Votre adresse email a déjà été vérifiée. Vous pouvez vous connecter à votre compte.',
      type: 'success',
    },
    invalid: {
      icon: 'bi-exclamation-circle-fill',
      title: 'Lien invalide',
      message:
        'Ce lien de vérification est invalide ou a déjà été utilisé. Vérifiez votre email ou demandez un nouveau lien.',
      type: 'error',
    },
    error: {
      icon: 'bi-x-circle-fill',
      title: 'Une erreur est survenue',
      message:
        'Nous n’avons pas pu vérifier votre adresse email. Veuillez réessayer ultérieurement.',
      type: 'error',
    },
  };

  const currentState = states[status] || {
    icon: 'bi-envelope-check',
    title: 'Vérification de votre email',
    message: 'Consultez le lien de vérification reçu par email pour activer votre compte.',
    type: 'info',
  };

  useEffect(() => {
    document.title = `${currentState.title} | MooviCar`;
  }, [currentState.title]);

  return (
    <div className="mc-email-verification">
      <div className="mc-gs-card mc-email-verification__card">
        <div
          className={`mc-email-verification__icon mc-email-verification__icon--${currentState.type}`}
        >
          <i className={`bi ${currentState.icon}`} aria-hidden="true" />
        </div>

        <div className="mc-email-verification__content">
          <span className="mc-email-verification__eyebrow">MOOVICAR · VOTRE COMPTE</span>

          <h1 className="mc-gs-card-title">{currentState.title}</h1>

          <p className="mc-email-verification__message">{currentState.message}</p>
        </div>

        <div
          className={`mc-gs-banner mc-gs-banner--${
            currentState.type === 'error' ? 'info' : currentState.type
          } mc-email-verification__banner`}
          role="status"
        >
          <i className={`bi ${currentState.icon}`} aria-hidden="true" />
          <span>
            {currentState.type === 'success'
              ? 'Vous pouvez maintenant accéder à votre espace.'
              : currentState.type === 'error'
                ? 'Si le problème persiste, contactez notre assistance.'
                : 'La sécurité de votre compte reste notre priorité.'}
          </span>
        </div>

        <div className="mc-email-verification__actions">
          <Link
            to="/account/demandes"
            className="mc-btn mc-btn--primary mc-email-verification__button"
          >
            <i className="bi bi-box-arrow-in-right" aria-hidden="true" />
            Mon espace
          </Link>

          <Link to="/" className="mc-btn mc-btn--ghost mc-email-verification__button">
            Retour à l'accueil
          </Link>
        </div>

        <p className="mc-email-verification__footer">
          Besoin d'aide ? Notre équipe reste à votre disposition.
        </p>
      </div>
    </div>
  );
}

export default EmailVerification;
